import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, useLocation, Link } from 'react-router-dom';
import useCustomFetchApi from '../utils/customFetchApi';

import './ThanksPage.scss';
import { useTranslation } from 'react-i18next';

const ThanksPage = ({ setIsParticipateShown }) => {

  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [loading, setLoading] = useState(true);
  const api = useCustomFetchApi();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {

    if (!sessionId) {
      setIsParticipateShown(true);
    } else {
      setIsParticipateShown(false);
    }

    return () => setIsParticipateShown(true);
  }, [setIsParticipateShown, sessionId]);

  useEffect(() => {
    const checkSession = async () => {
      if (sessionId) {
        try {
          setLoading(true);
          await api.get(`/payment/check?sessionId=${sessionId}`, { isLoadingMain: true, showNotification: true });
        } catch (error) {
          // errors handled globally
        } finally {
          // Extract the original path from current location
          // Current: /en/malaysia/payment/redirect or /my/malaysia/payment/redirect
          // Target: /en/malaysia or /my/malaysia
          const pathSegments = location.pathname.split('/').filter(Boolean);
          
          let originalPath = '/';
          
          // Remove 'payment' and 'redirect' from the end
          const filteredSegments = pathSegments.filter(segment => 
            segment !== 'payment' && segment !== 'redirect'
          );
          
          if (filteredSegments.length > 0) {
            originalPath = '/' + filteredSegments.join('/');
          }
          
//          console.log('Redirecting from', location.pathname, 'to', originalPath);
          navigate(`${originalPath}?success=THANK-YOU-FOR-YOUR-PARTICIPATION`);
        }
      } else {
        setLoading(false);
      }
    };

    checkSession();
  }, []);

  // Calculate the correct back path using the same logic as redirect
  const pathSegments = location.pathname.split('/').filter(Boolean);
  const filteredSegments = pathSegments.filter(segment => 
    segment !== 'payment' && segment !== 'redirect'
  );
  const backPath = filteredSegments.length > 0 ? '/' + filteredSegments.join('/') : '/';

  return (
    <div className="thanks-container">
      <div className="thanks-card">

        {loading && <p className="thanks-loading">{t('thanks.loading', 'Loading payment details...')}</p>}

        {!loading && sessionId && (
          <div>
            <div className="thanks-icon custom-checkmark"></div>
            <h1 className="thanks-title">{t('thanks.title', 'Thank You!')}</h1>
            <p className="thanks-message">
              {t('thanks.success', 'Your payment was successful.')}
            </p>
            <p>
              {t('thanks.redirecting', 'Redirecting ...')}
            </p>
          </div>
        )}

        {!loading && !sessionId && (
          <div>
            <p className="thanks-error">{t('thanks.noSession', 'No session ID found in the URL.')}</p>
            <Link to={backPath} className="thanks-back-button">{t('thanks.back', 'Back to Home')}</Link>
          </div>
        )}

      </div>
    </div>
  );
};

export default ThanksPage;
